import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'

import { Title, Heading4 } from '../styleguide'

import CTAButton from './CTAButton'

const styles = {
  titleStyle: {
    textTransform: 'uppercase',
    marginBottom: 4
  },
  headingStyle: {
    color: '#fff',
    lineHeight: 1.33
  }
}

const HeroBox = ({
  imageSource = 'https://picsum.photos/512/460',
  imageSource2x = 'https://picsum.photos/1024/460',
  height = 598,
  title,
  locations,
  teaser,
  classes: { titleStyle, headingStyle },
  width
}) => {
  const image = isWidthUp('lg', width) ? imageSource2x : imageSource
  return (
    <div
      style={{
        width: '50%',
        height: height,
        backgroundImage: `url(${image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div
        style={{
          height: height,
          padding: 35,
          display: 'flex',
          alignItems: 'flex-end'
        }}
      >
        <div>
          <Title className={titleStyle}>{title}</Title>
          <Heading4 gutterBottom className={headingStyle}>
            {teaser}
          </Heading4>
          {locations.map(({ location, ctaLabel }) => (
            <CTAButton key={location} location={location} label={ctaLabel} />
          ))}
        </div>
      </div>
    </div>
  )
}

HeroBox.propTypes = {
  title: PropTypes.string.isRequired,
  teaser: PropTypes.string.isRequired,
  locations: PropTypes.array.isRequired
}

export default withWidth()(withStyles(styles)(HeroBox))



// WEBPACK FOOTER //
// ./src/components/HeroBox.js